/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class DevicePath {
  id: string;
  deviceId: string;
  path: string;
}
